const CloseIconSvg = `
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g id="Close">
      <path 
        id="Icon (Stroke)" 
        fill-rule="evenodd" 
        clip-rule="evenodd" 
        d="M5.99991 4.68579L11.9999 
            10.6858L17.9999 
            4.68579L19.4141 
            6.1L13.4141 
            12.1L19.4141 
            18.1L17.9999 
            19.5142L11.9999 
            13.5142L5.99991 
            19.5142L4.58569 
            18.1L10.5857 
            12.1L4.58569 
            6.1L5.99991 
            4.68579Z" 
        fill="#17191C"
      />
    </g>
  </svg>
`

export default class TurnstileModal {
  constructor({
    content,
    onClose,
  }) {
    this.content = content
    this.onClose = onClose
  }

  static injectStyles() {
    const styles = `
      .turnstile-container {
        position: fixed;
        height: 100vh;
        width: 100vw;
        z-index: 1000;
      }
      
      .background-layer {
        position: absolute;
        top: 0;
        width: 100vw;
        height: 100%;
        z-index: 1;
        background-color: rgba(0, 0, 0, 0.5);
      }
      
      .modal {
        position: relative;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 330px;
        background: #FFF;
        border-radius: 4px;
        z-index: 2;
      }

      .modal-header {
        position: relative;
        padding: 32px 10px 20px 10px;
      }

      .modal-header .title {
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 29px;
        text-align: center;
      }

      .modal-header .close-button {
        position: absolute;
        top: 16px;
        right: 16px;
        cursor: pointer;
      }

      .modal-content {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 65px;
      }

      .modal-footer {
        height: 32px;
      }
    `

    const styleSheet = document.createElement('style')
    styleSheet.innerText = styles.replace(/\s+/g, ' ').trim() // NOTE: 스타일시트 주입 시 빈 문자열 제거
    document.head.insertAdjacentElement('beforeend', styleSheet)
  }

  #insertModal({ message }) {
    const container = document.createElement('div')
    container.classList.add('turnstile-container')

    const backgroundLayer = document.createElement('div')
    backgroundLayer.classList.add('background-layer')

    const modalHtml = `
      <div class="modal">
        <div class="modal-header">
          <div class="title">${message}</div>
          <div class="close-button">
            ${CloseIconSvg}
          </div>
        </div>
        <div class="modal-content">
          ${this.content.outerHTML}
        </div>
        <div class="modal-footer">
        </div>
      </div>
    `

    container.innerHTML = modalHtml

    document.body.innerHTML = ''
    document.body.appendChild(backgroundLayer)
    document.body.appendChild(container)

    const closeBtn = document.querySelector('.close-button')
    closeBtn.addEventListener('click', this.onClose)
  }

  show({ message }) {
    TurnstileModal.injectStyles()
    this.#insertModal({ message })
  }
}
